<template>
  <div
      class="swiper-bg-1 flex flex-col gap-[51px] sm:gap-12 px-8 lg:px-16 py-16 rounded-3xl overflow-hidden bg-no-repeat bg-cover transition-all duration-1000"
      id="banner">

    <!-- Заголовки -->
    <BannerTitle/>

    <!-- Контейнер слайдеров -->
    <div class="grow -mt-[20px] lg:mt-0 pt-0 relative">
      <div class="swiper-second" ref="swiperSecondRef">
        <div class="swiper-wrapper items-center">

          <!-- Слайд 1: Группа из 3 телефонов -->
          <div class="swiper-slide" data-bg="banner-1.png">
            <div class="h-full flex items-center justify-center relative">
              <!-- Внутренний слайдер: 3 телефона -->
              <div class="swiper-first swiper-inner w-[130px] sm:w-auto sm:max-w-[200px] relative" ref="swiperFirstRef">
                <div class="swiper-wrapper">
                  <div class="swiper-slide flex justify-center" data-bg="banner-1.png">
                    <img src="/stima/assets/images/slides/banner-1/Phone-1.png" alt=""
                         class="w-[130px] sm:w-[200px] h-[270px] lg:h-[400px] object-contain">
                  </div>
                  <div class="swiper-slide flex justify-center" data-bg="banner-2.png">
                    <img src="/stima/assets/images/slides/banner-1/Phone-2.png" alt=""
                         class="w-[130px] sm:w-[200px] h-[270px] lg:h-[400px] object-contain">
                  </div>
                  <div class="swiper-slide flex justify-center" data-bg="banner-3.png">
                    <img src="/stima/assets/images/slides/banner-1/Phone-3.png" alt=""
                         class="w-[130px] sm:w-[200px] h-[270px] lg:h-[400px] object-contain">
                  </div>
                  <div class="swiper-slide hidden" data-bg="banner-1.png"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Слайд 2: QR-код -->
          <div class="swiper-slide h-auto flex items-center justify-center"
               data-bg="banner-4.png">
            <div class="h-full flex items-center justify-center">
              <div class="w-[212px] h-[212px]">
                <img src="/stima/assets/images/slides/banner-1/qrcode.png" alt="QR Code"
                     class="w-full h-full object-contain">
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


    <!-- Единая пагинация -->
    <div class="swiper-pagination-c">
      <DotSliderComponent
          ref="dotSliderRef"
          v-model="currentSlide"
          :length="4"
          :dot-style="{
            width: '8px',
            height: '8px',
            opacity: '.5',
            backgroundColor: '#ffffff',
            margin: '0 4px'
          }"
      />
    </div>

  </div>
</template>

<script setup>

const dotSliderRef = ref(null);
const currentSlide = ref(0);

import {ref, onMounted} from 'vue';
import Swiper from 'swiper';
import {EffectCreative, Pagination, Navigation, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import {switchTitle} from '@/stima/js/animatins';
import BannerTitle from './BannerTitle.vue';
import DotSliderComponent from "@/page/landing_v2/animation/DotSliderComponent.vue";

// Рефы для DOM элементов
const swiperFirstRef = ref(null);
const swiperSecondRef = ref(null);

// Флаг для отслеживания программных переключений
let isProgrammaticSlide = false;

// Инстансы слайдеров
let swiperFirst = null;
let swiperSecond = null;

// Функция смены фона
const changeSlideBackground = (sw) => {
  const bgElement = document.querySelector('#banner');
  const real = sw.realIndex;
  const slideEl = sw.slides[real];
  const bgName = slideEl.getAttribute('data-bg');

  // Удаляем все классы фона
  bgElement.classList.remove('swiper-bg-1', 'swiper-bg-2', 'swiper-bg-3', 'swiper-bg-4');

  // Определяем класс на основе data-bg
  const bgClassMap = {
    'banner-1.png': 'swiper-bg-1',
    'banner-2.png': 'swiper-bg-2',
    'banner-3.png': 'swiper-bg-3',
    'banner-4.png': 'swiper-bg-4'
  };

  const bgClass = bgClassMap[bgName];
  if (bgClass) {
    bgElement.classList.add(bgClass);
  }
};

// Инициализация слайдеров после монтирования компонента
onMounted(() => {
  // Внешний слайдер (телефоны → QR-код)
  swiperSecond = new Swiper(swiperSecondRef.value, {
    modules: [Autoplay],
    autoplay: {
      delay: 2000
    },
    slidesPerView: 1,
    speed: 700,
    on: {
      slideChange: (sw) => {
        if (sw.realIndex === 1) {
          changeSlideBackground(sw);
          switchTitle(0, 4);
        } else if (sw.realIndex === 0) {
          switchTitle(4, 0);

          setTimeout(() => {
            sw.disable();
          }, 700);
        }
      },
      slideChangeTransitionStart: (sw) => {
        if (sw.realIndex === 0) {
          // Устанавливаем флаг перед программным переключением
          isProgrammaticSlide = true;
          swiperFirst.slideTo(0, 700);
          // Сбрасываем флаг после небольшой задержки
          setTimeout(() => {
            isProgrammaticSlide = false;
          }, 100);
        }
      }
    }
  });

  // Внутренний слайдер (3 телефона)
  swiperFirst = new Swiper(swiperFirstRef.value, {
    modules: [EffectCreative, Navigation, Pagination, Autoplay],
    effect: 'creative',
    centeredSlides: true,
    slidesPerView: 1,
    speed: 700,
    autoplay: {
      delay: 2000
    },
    creativeEffect: {
      prev: {
        translate: ['-50%', 0, 0],
        scale: 0.7,
      },
      next: {
        translate: ['50%', 0, 0],
        scale: 0.7,
      },
    },
    // pagination: {
    //   el: '.swiper-pagination-c',
    //   bulletClass: 'bullet',
    //   bulletActiveClass: 'bullet-active'
    // },
    // navigation: {
    //   nextEl: '.el-next',
    //   prevEl: '.el-prev'
    // },
    on: {
      init: (sw) => {
        swiperSecond.disable();
      },
      slideChange: (sw) => {
        dotSliderRef.value?.setIndex(sw.activeIndex);

      },
      slideChangeTransitionStart: (sw) => {
        if (sw.realIndex !== 4) {
          changeSlideBackground(sw);
        }
        if (sw.realIndex === 3) {
          swiperSecond.enable();
          sw.slideNext();
          swiperSecond.slideNext();
        }
      },
    }
  });
});
</script>
